export default "__VITE_ASSET__BVBWAFFU__"